import Button from '@/components/core/Button';
import ButtonIcon from '@/components/core/ButtonIcon';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import { addMonths, parse, subMonths } from 'date-fns';
import React from 'react';
import Filters, { PhysicianDropdown } from '../kiosk/schedule/Filters';

export const MonthPicker = ({ date, setDate }) => {
  const classes = useStyles();

  return (
    <div className={classes.picker}>
      <ButtonIcon onClick={() => setDate(subMonths(date, 1))}>
        <KeyboardArrowLeft />
      </ButtonIcon>
      <div>
        <Filters
          date={date}
          withoutPhysician
          onChange={({ date }) => setDate(parse(date))}
          noSpacingStyles
          buttonFormat={'MMMM YYYY'}
        />
      </div>
      <ButtonIcon onClick={() => setDate(addMonths(date, 1))}>
        <KeyboardArrowRight />
      </ButtonIcon>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  picker: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

const LegacyActionBar = ({ date, setDate, physician, setPhysician, colorMode, setColorMode }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Button onClick={() => setColorMode(!colorMode)} disabled={!setColorMode}>
          {!colorMode ? 'Category View' : 'Physician View'}
        </Button>
      </div>
      <div style={{ minWidth: 300 }}>
        <PhysicianDropdown onChange={setPhysician} value={physician} />
      </div>
      {setDate && <MonthPicker date={date} setDate={setDate} />}
    </div>
  );
};

export default LegacyActionBar;
